import { createAction, props } from '@ngrx/store';

import { ICollectionUPPDState, IPortfolioUPPDState } from '@shared/enums/property-type.enum';

import { PropertySelectorSwitchStatus } from '../reducers/property-selector.reducer';

export const initPropertySelector = createAction(
  '[PropertySelector] initPropertySelector',
  props<{
    userId: number;
    tenantId: number;
  }>()
);

export const setPropertySelectorSwitchStatus = createAction(
  '[PropertySelector] Set Properties or Collections',
  props<{ propertySelectorSwitchStatus: PropertySelectorSwitchStatus; doNotStore?: boolean }>()
);

export const setSelectedPortfolioId = createAction(
  '[PropertySelector] Selected portfolio id',
  props<{
    portfolioId: number | null;
  }>()
);

export const setPropertySingleMode = createAction(
  '[PropertySelector] Single mode',
  props<{
    singleMode: boolean;
  }>()
);

export const setSelectedPropertyIds = createAction(
  '[PropertySelector] Selected property ids',
  props<{
    propertyIds: number[] | null;
    allPropertiesSelected: boolean;
  }>()
);

export const setPortfolioUPPDState = createAction(
  '[PropertySelector] Portfolio uppd state',
  props<{ data: IPortfolioUPPDState }>()
);

export const setCollectionUPPDState = createAction(
  '[PropertySelector] Collection uppd state',
  props<{ data: ICollectionUPPDState }>()
);

export const clearPortfolioUPPDState = createAction('[PropertySelector] Clear portfolio uppd state');

export const clearCollectionUPPDState = createAction('[PropertySelector] Clear collection uppd state');

export const setSelectedCollectionIds = createAction(
  '[PropertySelector] Selected collection ids',
  props<{ collectionIds: number[] | null; allCollectionsSelected: boolean; doNotStore?: boolean }>()
);

export const removeSelectedCollectionId = createAction(
  '[PropertySelector] Remove collection',
  props<{ collectionId: number }>()
);

export const setJoinedCollections = createAction(
  '[PropertySelector] join collections',
  props<{ state: boolean; doNotStore?: boolean }>()
);

export const setJoinedProperties = createAction(
  '[PropertySelector] join properties',
  props<{ state: boolean; doNotStore?: boolean }>()
);

export const setDoNotStore = createAction('[Property Selector] Set Do Not Store', props<{ doNotStore: boolean }>());

export const restorePropertySelectorState = createAction(
  '[PropertySelector] Restore Property Selector State',
  props<{
    propertySelectorSwitchStatus: PropertySelectorSwitchStatus;
    collectionIds: number[] | null;
    portfolioId: number | null;
  }>()
);
